// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PoleServicesMapWidget_card__GtOkR {
  background: #ffffff;
  border: 1px solid #dce3e8;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(30, 55, 75, 0.06);
  padding: 12px;
}

.PoleServicesMapWidget_header__RKb7o {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 10px;
}

.PoleServicesMapWidget_tabs__PkqxA {
  display: flex;
  align-items: center;
  gap: 18px;
}

.PoleServicesMapWidget_tab__ZejfC,
.PoleServicesMapWidget_activeTab__0T6jw {
  appearance: none;
  border: 0;
  border-bottom: 3px solid transparent;
  padding: 0 0 5px;
  background: transparent;
  color: #596b7a;
  font: inherit;
  font-size: 0.88rem;
  cursor: pointer;
}

.PoleServicesMapWidget_activeTab__0T6jw {
  border-bottom-color: #155aa8;
  color: #155aa8;
  font-weight: 700;
}

.PoleServicesMapWidget_tab__ZejfC:hover,
.PoleServicesMapWidget_tab__ZejfC:focus-visible,
.PoleServicesMapWidget_activeTab__0T6jw:focus-visible {
  color: #155aa8;
  outline: none;
}

.PoleServicesMapWidget_poleName__Uic6W {
  color: #243746;
  font-size: 0.88rem;
  font-weight: 600;
}

.PoleServicesMapWidget_mapShell__E8RT0 {
  position: relative;
  min-height: 560px;
  overflow: hidden;
  border-radius: 9px;
  border: 1px solid #d2dce2;
  background: #eef2f4;
}

.PoleServicesMapWidget_map__yOS2S {
  width: 100%;
  height: 560px;
  background: #eef2f4;
}

.PoleServicesMapWidget_state__Fn2Xz,
.PoleServicesMapWidget_error__HkuaU {
  position: absolute;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  text-align: center;
  background: rgba(238, 242, 244, 0.94);
  color: #526b7f;
}

.PoleServicesMapWidget_error__HkuaU {
  color: #b42318;
}

.PoleServicesMapWidget_mapLabel__5vzCE {
  width: auto !important;
  height: auto !important;
  margin: 0 !important;
  transform: translate(-50%, -50%);
  background: transparent;
  border: 0;
}

.PoleServicesMapWidget_mapLabel__5vzCE span {
  display: block;
  max-width: 120px;
  padding: 4px 7px;
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.9);
  color: #1f3443;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.15;
  text-align: center;
  white-space: normal;
  box-shadow: 0 1px 4px rgba(30, 55, 75, 0.15);
}

.PoleServicesMapWidget_statsOverlay__Lvapz {
  position: absolute;
  z-index: 900;
  transform: translate(-50%, -50%);
  pointer-events: none;
  will-change: left, top;
}

@media (max-width: 1100px) {
  .PoleServicesMapWidget_map__yOS2S,
  .PoleServicesMapWidget_mapShell__E8RT0 {
    height: 460px;
    min-height: 460px;
  }
}

@media (max-width: 760px) {
  .PoleServicesMapWidget_header__RKb7o {
    align-items: flex-start;
    flex-direction: column;
  }

  .PoleServicesMapWidget_map__yOS2S,
  .PoleServicesMapWidget_mapShell__E8RT0 {
    height: 360px;
    min-height: 360px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Overview/PoleServicesMapWidget.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;EAC5C,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,gBAAgB;EAChB,SAAS;EACT,oCAAoC;EACpC,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;EAGE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,gCAAgC;EAChC,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gCAAgC;EAChC,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE;;IAEE,aAAa;IACb,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;;IAEE,aAAa;IACb,iBAAiB;EACnB;AACF","sourcesContent":[".card {\r\n  background: #ffffff;\r\n  border: 1px solid #dce3e8;\r\n  border-radius: 12px;\r\n  box-shadow: 0 2px 8px rgba(30, 55, 75, 0.06);\r\n  padding: 12px;\r\n}\r\n\r\n.header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 16px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.tabs {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 18px;\r\n}\r\n\r\n.tab,\r\n.activeTab {\r\n  appearance: none;\r\n  border: 0;\r\n  border-bottom: 3px solid transparent;\r\n  padding: 0 0 5px;\r\n  background: transparent;\r\n  color: #596b7a;\r\n  font: inherit;\r\n  font-size: 0.88rem;\r\n  cursor: pointer;\r\n}\r\n\r\n.activeTab {\r\n  border-bottom-color: #155aa8;\r\n  color: #155aa8;\r\n  font-weight: 700;\r\n}\r\n\r\n.tab:hover,\r\n.tab:focus-visible,\r\n.activeTab:focus-visible {\r\n  color: #155aa8;\r\n  outline: none;\r\n}\r\n\r\n.poleName {\r\n  color: #243746;\r\n  font-size: 0.88rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.mapShell {\r\n  position: relative;\r\n  min-height: 560px;\r\n  overflow: hidden;\r\n  border-radius: 9px;\r\n  border: 1px solid #d2dce2;\r\n  background: #eef2f4;\r\n}\r\n\r\n.map {\r\n  width: 100%;\r\n  height: 560px;\r\n  background: #eef2f4;\r\n}\r\n\r\n.state,\r\n.error {\r\n  position: absolute;\r\n  inset: 0;\r\n  z-index: 1200;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 20px;\r\n  text-align: center;\r\n  background: rgba(238, 242, 244, 0.94);\r\n  color: #526b7f;\r\n}\r\n\r\n.error {\r\n  color: #b42318;\r\n}\r\n\r\n.mapLabel {\r\n  width: auto !important;\r\n  height: auto !important;\r\n  margin: 0 !important;\r\n  transform: translate(-50%, -50%);\r\n  background: transparent;\r\n  border: 0;\r\n}\r\n\r\n.mapLabel span {\r\n  display: block;\r\n  max-width: 120px;\r\n  padding: 4px 7px;\r\n  border-radius: 5px;\r\n  background: rgba(255, 255, 255, 0.9);\r\n  color: #1f3443;\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  line-height: 1.15;\r\n  text-align: center;\r\n  white-space: normal;\r\n  box-shadow: 0 1px 4px rgba(30, 55, 75, 0.15);\r\n}\r\n\r\n.statsOverlay {\r\n  position: absolute;\r\n  z-index: 900;\r\n  transform: translate(-50%, -50%);\r\n  pointer-events: none;\r\n  will-change: left, top;\r\n}\r\n\r\n@media (max-width: 1100px) {\r\n  .map,\r\n  .mapShell {\r\n    height: 460px;\r\n    min-height: 460px;\r\n  }\r\n}\r\n\r\n@media (max-width: 760px) {\r\n  .header {\r\n    align-items: flex-start;\r\n    flex-direction: column;\r\n  }\r\n\r\n  .map,\r\n  .mapShell {\r\n    height: 360px;\r\n    min-height: 360px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `PoleServicesMapWidget_card__GtOkR`,
	"header": `PoleServicesMapWidget_header__RKb7o`,
	"tabs": `PoleServicesMapWidget_tabs__PkqxA`,
	"tab": `PoleServicesMapWidget_tab__ZejfC`,
	"activeTab": `PoleServicesMapWidget_activeTab__0T6jw`,
	"poleName": `PoleServicesMapWidget_poleName__Uic6W`,
	"mapShell": `PoleServicesMapWidget_mapShell__E8RT0`,
	"map": `PoleServicesMapWidget_map__yOS2S`,
	"state": `PoleServicesMapWidget_state__Fn2Xz`,
	"error": `PoleServicesMapWidget_error__HkuaU`,
	"mapLabel": `PoleServicesMapWidget_mapLabel__5vzCE`,
	"statsOverlay": `PoleServicesMapWidget_statsOverlay__Lvapz`
};
export default ___CSS_LOADER_EXPORT___;
